import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body {
    --background: ${({ theme }) => theme.body};
    --text: ${({ theme }) => theme.text};
    background-color: var(--background);
    color: var(--text);
    transition: all 0.3s linear;
  }
`;

export const lightTheme = {
  body: '#ededed',
  text: '#1b1725',
};

export const darkTheme = {
  body: '#1b1725',
  text: '#ededed',
};